import LMask from './src/main'

/* istanbul ignore next */
LMask.install = function(Vue) {
  Vue.component(LMask.name, LMask)
}

export default LMask
